<template>

<div>
	<!--<div class="row mt-2" v-for="Item in Items" :key="Item.patientCode">
		<div class="float-left col-md-4 text-muted" style="background-color: lightgray;">
			<small>patientName</small><br>
			<b>{{Item.patientName}}</b>
		</div>
		<div class="float-left col-md-4 text-muted" style="background-color: lightgray;">
			<small>DOB</small><br>
			<b>{{formatDOB(Item.dob)}}</b>
		</div>
		<div class="float-left col-md-4 text-muted" style="background-color: lightgray;">
			<small>SEX</small><br>
			<b>{{Item.sex}}</b>
		</div>
		<div class="row mt-2" v-for="Item2 in Item.timedAdministrations" :key="Item2.recordID" style="margin-left: 0px;">
			
					<div class="float-left col-md-2 text-muted">
						<b>{{Item2.drugCode}}</b>
					</div>
					<div class="float-left col-md-10 text-muted">
						<b>{{Item2.sig}}</b>
					</div>
		</div>
	</div>-->

	<div class="zebraAccordion">
		<div class="zebraRow" v-for="(item, index) in Items" :key="index"> 

		<div class="accordion" role="tablist" >              
			<div class="zebraItem" v-b-toggle="'accordion-'+index">
				<b-row class="d-flex align-items-center">
					<!--<b-col md="1">    						
						<div v-if="HaveOneGiven(index)" class="zItemIcon"><i class="ikon med-adm-given h3" v-b-tooltip.hover :title="$t('modalMarsMed.Given')"></i></div>
						<div v-if="HaveOneNoGiven(index) && !HaveOneGiven(index)" class="zItemIcon"><i class="ikon med-adm-not-given h3" v-b-tooltip.hover :title="$t('modalMarsMed.NoGiven')"></i></div>											
						<div v-if="GivenNeutro(index) && item.needAssessment" class="zItemIcon"><i class="ikon med-adm-not-selected h3" v-b-tooltip.hover :title="$t('modalMarsMed.Neutral')"></i></div>
					</b-col>-->
					<b-col md="12">	

						<div class="float-left col-md-2">
							<small>{{$t('Shared.PatientName')}}</small><br>
							<span v-if="item.patientName">{{item.patientName}}</span>
							<span v-else>{{$t('Shared.Notdefined')}}</span>
						</div>
						
						<div class="float-left col-md-2">
							<small>{{$t('Shared.PatientCode')}}</small><br>
							<span v-if="item.patientCode">{{item.patientCode}}</span>
							<span v-else>{{$t('Shared.Notdefined')}}</span>
						</div>
						<div class="float-left col-md-2">
							<small>{{$t('Shared.Dob')}}</small><br>
							<span v-if="item.dob">{{formatDate(item.dob)}}</span>
							<span v-else>{{$t('Shared.Notdefined')}}</span>
						</div>

						<div class="float-left col-md-2">
							<small>{{$t('Shared.Age')}}</small><br>
							<span v-if="item.ageFormatted">{{item.ageFormatted}}</span>
							<span v-else>{{$t('Shared.Notdefined')}}</span>
						</div>			
<!--
						<div class="float-left col-md-1 text-muted" v-if="item.sex">
							<small>{{$t('Shared.Sex')}}</small><br>
							<b>{{item.sex}}</b>
						</div>
						<div class="float-left col-md-1 text-muted" v-else>
							<small>{{$t('Shared.Sex')}}</small><br>
							<b>{{$t('Shared.Notdefined')}}</b>
						</div>
-->
						<div class="float-left col-md-4">
							<small>{{$tc('Shared.Program',1)}}</small><br>
							<span v-if="item.programName">{{item.programName}}</span>
							<span v-else>{{$t('Shared.Notdefined')}}</span>
						</div>					  
<!--
						<div class="float-left col-md-2 text-muted" v-if="item.buildingName">							
							<small>{{$t('Shared.BuildingName')}}</small><br>
							<b>{{item.buildingName}}</b>
						</div>
						<div class="float-left col-md-2 text-muted" v-else>
							<small>{{$t('Shared.BuildingName')}}</small><br>
							<b>{{$t('Shared.Notdefined')}}</b>
						</div>  

						<div class="float-left col-md-2 text-muted" v-if="item.roomLevel">							
							<small>{{$t('modalMarsMed.RoomLevel')}}</small><br>
							<b>{{item.roomLevel}}</b>
						</div>
						<div class="float-left col-md-2 text-muted" v-else>
							<small>{{$t('modalMarsMed.RoomLevel')}}</small><br>
							<b>{{$t('Shared.Notdefined')}}</b>
						</div> 

						<div class="float-left col-md-2 text-muted" v-if="item.roomName">							
							<small>{{$tc('Shared.Room')}}</small><br>
							<b>{{item.roomName}}</b>
						</div>
						<div class="float-left col-md-2 text-muted" v-else>
							<small>{{$t('Shared.RoomName')}}</small><br>
							<b>{{$t('Shared.Notdefined')}}</b>
						</div> 

						<div class="float-left col-md-1 text-muted" v-if="item.bedName">						
							<small>{{$tc('Shared.Bed')}}</small><br>
							<b>{{item.bedName}}</b>
						</div>	
						<div class="float-left col-md-1 text-muted" v-else>
							<small>{{$tc('Shared.Bed')}}</small><br>
							<b>{{$t('Shared.Notdefined')}}</b>
						</div> 
						-->					
					</b-col>				
				</b-row>                   

			</div>
			<b-card no-body>                 
				<b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
					<b-card-body class="accordionContent pt-3" style="padding: 10px !important;">  
                  
					<div v-if="item.timedMedications.length > 0 && item.timedMedications[0].recordID !== null">
						<MdTitle v-bind:Text="$t('modalMarsMed.TimedMedications')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>					
						<div class="card" v-for="(timed, tindex) in item.timedMedications" :key="'Timed_'+index+'_'+tindex">							
							<div class="container-mars mt-3">
								<div class="card-container">
									<div class="card-body">
										<div class="row patPhoto-container">										
											<div class="col-md-12 resetFontSize">
												<div class="row">
													<div class="col-md-4 text-muted p-item" v-if="timed.drugName">
														<small>{{$t('Shared.DrugName')}}</small><br>
															<b>{{ timed.drugName }}</b>
													</div>
													<div class="col-md-4 text-muted p-item" v-else>
														<small>{{$t('Shared.DrugName')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>

													<div class="col-md-1 text-muted p-item" v-if="timed.qtySet">
														<small>{{$t('Shared.Dosage')}}</small><br>
														<b>{{ timed.qtySet }} {{ timed.dispensingUOM }}</b>
													</div>
	
													<div class="col-md-1 text-muted p-item" v-else>
														<small>{{$t('Shared.Dosage')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>	
	
													<div class="col-md-5 text-muted p-item" v-if="timed.sig">
														<small>{{$t('Shared.Sig')}}</small><br>
														<b>{{ timed.sig }}</b>
													</div>
													<div class="col-md-5 text-muted p-item" v-else>
														<small>{{$t('Shared.Sig')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>
	
													<div class="col-md-2 text-muted p-item" v-if="timed.prescriberName">
														<small>{{$t('modalMarsMed.PrescriberName')}} </small><br>
														<b>{{ timed.prescriberName }}</b>
													</div>
													<div class="col-md-2 text-muted p-item" v-else>
														<small>{{$t('modalMarsMed.PrescriberName')}} </small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>	
													
												</div>
												<div v-for="(data, tdataindex) in timed.administrationsByMonth" :key="'Timed_Data'+index+'ByMonth_'+tindex+'_'+tdataindex" style="overflow-x:auto;" class="mb-3">												
													<div class="longDivider"><span class="adminTime">{{formatTime(data["adminTime_Day"+(tdataindex+1)])}}</span></div>
													<table class="text-center vertical-center ml-2">
														<thead>
															<tr>
																<th class="text-right text-muted">Days</th><th class="silverTextColor" v-for="(day, tdayindex) in 31" :key="'Timed_Day'+index+'Th_'+tdataindex+'_'+tdayindex" style="width:50px; overflow: visible;">{{day}}</th>																									
															</tr>
														</thead>
														<tbody>
															<tr>
																<td class="text-right text-muted">Status</td>												
																<td v-for="(daydata, tdaydataindex) in 31" :key="'Timed_Given'+index+'Td_'+tindex+'_'+tdaydataindex">
																	
																	<b-tooltip :target="'ViewIcon-'+'Timed_Given'+index+'Td_'+tindex+'_'+tdaydataindex+data['recNo_Day'+(tdaydataindex+1)]" >
																		<h6 class="eventHintHeader text-uppercase">{{$t('modalMarsMed.AdministrationDetail')}}</h6>
																		<div class="eventHint">
																			<span><i :class="data['given_Day'+(tdaydataindex+1)] ? 'ikon med-adm-given h6' : data['given_Day'+(tdaydataindex+1)] === false ? 'ikon med-adm-not-given h6' : 'ikon med-adm-not-selected h6'" style="position: relative; left: -2px; top: 2px;"></i> {{$t('Shared.Status')}}: {{data['given_Day'+(tdaydataindex+1)] ? $t('modalMarsMed.Given') : data['given_Day'+(tdaydataindex+1)] === false ? $t('modalMarsMed.NoGiven') : $t('modalMarsMed.Neutral')}}</span><br>
																			<span v-if="data['adminDate_Day'+(tdaydataindex+1)]"><b-icon icon="calendar-event"></b-icon>{{$t('Shared.AdminDate')}}: {{formatDate(data['adminDate_Day'+(tdaydataindex+1)])}}</span><br v-if="data['adminDate_Day'+(tdaydataindex+1)]">
																			<span v-if="data['adminTime_Day'+(tdaydataindex+1)]"><b-icon icon="clock"></b-icon>{{$t('Shared.AdminTime')}}: {{formatTime(data['adminTime_Day'+(tdaydataindex+1)])}}</span><br v-if="data['adminTime_Day'+(tdaydataindex+1)]">
																			<span v-if="data['givenDate_Day'+(tdaydataindex+1)]"><b-icon icon="calendar4-week"></b-icon>{{$t('modalMarsMed.GivenDate')}}: {{formatDate(data['givenDate_Day'+(tdaydataindex+1)])}}</span><br v-if="data['givenDate_Day'+(tdaydataindex+1)]">
																			<span v-if="data['givenTime_Day'+(tdaydataindex+1)]"><b-icon icon="clock-history"></b-icon>{{$t('Shared.GivenTime')}}: {{formatTime(data['givenTime_Day'+(tdaydataindex+1)])}}</span><br v-if="data['givenTime_Day'+(tdaydataindex+1)]">
																			<span v-if="data['givenQTY_Day'+(tdaydataindex+1)]"><b-icon icon="layers-half"></b-icon>{{$t('Shared.quantity')}}: {{data['givenQTY_Day'+(tdaydataindex+1)]}}</span><br v-if="data['givenQTY_Day'+(tdaydataindex+1)]">
																			<span v-if="data['reasonDescription_Day'+(tdaydataindex+1)]"><b-icon icon="pen"></b-icon>{{$t('Shared.Reason')}}: {{data['reasonDescription_Day'+(tdaydataindex+1)]}}</span><br v-if="data['reasonDescription_Day'+(tdaydataindex+1)]">																
																			<span v-if="data['reviewedByName_Day'+(tdaydataindex+1)] !== null && data['reviewedByName_Day'+(tdaydataindex+1)].trim()"><b-icon icon="person"></b-icon>{{$t('modalMarsMed.ReviewedBy')}}: {{data['reviewedByName_Day'+(tdaydataindex+1)]}}</span><br v-if="data['reviewedByName_Day'+(tdaydataindex+1)] !== null && data['reviewedByName_Day'+(tdaydataindex+1)].trim()">
																			<span v-if="data['reviewedOn_Day'+(tdaydataindex+1)]"><b-icon icon="calendar2-check"></b-icon>{{$t('modalMarsMed.ReviewedOn')}}: {{formatDate(data['reviewedOn_Day'+(tdaydataindex+1)])}}</span>
																		</div>
																	</b-tooltip>	
																	
																	<div :id="'ViewIcon-'+'Timed_Given'+index+'Td_'+tindex+'_'+tdaydataindex+data['recNo_Day'+(tdaydataindex+1)]" style="cursor:pointer" v-if="data['given_Day'+(tdaydataindex+1)] === true"><i class="ikon med-adm-given greenIconColor"></i></div>
																	<div :id="'ViewIcon-'+'Timed_Given'+index+'Td_'+tindex+'_'+tdaydataindex+data['recNo_Day'+(tdaydataindex+1)]" style="cursor:pointer" v-if="data['given_Day'+(tdaydataindex+1)] === false"><i class="ikon med-adm-not-given redIconColor"></i></div> 															
																	<div :id="'ViewIcon-'+'Timed_Given'+index+'Td_'+tindex+'_'+tdaydataindex+data['recNo_Day'+(tdaydataindex+1)]" style="cursor:pointer" v-if="data['given_Day'+(tdaydataindex+1)] === null && data['recNo_Day'+(tdaydataindex+1)] !== 0 "><i class="ikon med-adm-not-selected silverIconColor"></i></div>
																</td>
															</tr>
														</tbody>
													</table>
													
												</div>											
											</div>
										</div>                                       
									</div>
								</div>
							</div>    
						</div>
					</div>
				

					<div v-if="item.prnMedications.length > 0 && item.prnMedications[0].recordID !== null">
						<MdTitle  v-bind:Text="$t('modalMarsMed.PRNMedications')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
						<div class="card activeCard" v-for="(prn, pindex) in item.prnMedications" :key="'prn_'+index+'_'+pindex" >			
							<div class="container-mars mt-3">
								<div class="card-container">
									<div class="card-body">
										<div class="row patPhoto-container">								
											<div class="col-md-12 resetFontSize">
												<div class="row">
													<div class="col-md-4 text-muted p-item" v-if="prn.drugName">
														<small>{{$t('Shared.DrugName')}}</small><br>                                                   
														<b>{{ prn.drugName }}</b>
													</div>
													<div class="col-md-4 text-muted p-item" v-else>
														<small>{{$t('Shared.DrugName')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>

													<div class="col-md-1 text-muted p-item" v-if="prn.qtySet">
														<small>{{$t('Shared.Dosage')}}</small><br>
														<b>{{ prn.qtySet }} {{ prn.dispensingUOM }}</b>
													</div>
													<div class="col-md-1 text-muted p-item" v-else>
														<small>{{$t('Shared.Dosage')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>	

													<div class="col-md-5 text-muted p-item" v-if="prn.sig">
														<small>{{$t('Shared.Sig')}}</small><br>
														<b>{{ prn.sig }}</b>
													</div>
													<div class="col-md-5 text-muted p-item" v-else>
														<small>{{$t('Shared.Sig')}}</small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>

													<div class="col-md-2 text-muted p-item" v-if="prn.prescriberName">
														<small>{{$t('modalMarsMed.PrescriberName')}} </small><br>
														<b>{{ prn.prescriberName }}</b>
													</div>
													<div class="col-md-2 text-muted p-item" v-else>
														<small>{{$t('modalMarsMed.PrescriberName')}} </small><br>
														<b>{{$t('Shared.Notdefined')}}</b>
													</div>   
											
												</div>

												<hr>
												<div v-for="(prnadm, padmindex) in prn.administrations" :key="'Prn_Adm'+index+'adm_'+pindex+'_'+padmindex">	
													<div class="row">
														<div class="col-md-2 text-muted p-item" v-if="prnadm.givenDateTime">
															<small>{{$t('Shared.DateAndTime')}}</small><br>                                                   
															<b>{{ prnadm.givenDateTime }}</b>
														</div>
														<div class="col-md-2 text-muted p-item" v-else>
															<small>{{$t('Shared.DateAndTime')}}</small><br>
															<b>{{$t('Shared.Notdefined')}}</b>
														</div>	
														
														<div class="col-md-1 text-muted p-item" v-if="prnadm.given">
															<small>{{$t('modalMarsMed.Given')}}</small><br>                                                   
															<div class="zItemIcon"><i class="ikon med-adm-given h3 greenIconColor"></i></div>
														</div>

														<div class="col-md-1 text-muted p-item" v-if="!prnadm.given">
															<small>{{$t('modalMarsMed.NoGiven')}}</small><br>                                                   
															<div class="zItemIcon"><i class="ikon med-adm-not-given h3 redIconColor"></i></div> 
														</div>

														<div class="col-md-1 text-muted p-item" v-if="prnadm.given === null">
															<small>{{$t('modalMarsMed.Neutral')}}</small><br>                                                   
															<div class="zItemIcon"><i class="ikon med-adm-not-selected h3"></i></div> 
														</div>																										
														
														<div class="col-md-2 text-muted p-item" v-if="prnadm.givenQTY">
															<small>{{$t('modalMarsMed.GivenQuantity')}}</small><br>                                                   
															<b>{{ prnadm.givenQTY }} - {{prn.dispensingUOM}}</b>
														</div>
														<div class="col-md-2 text-muted p-item" v-else>
															<small>{{$t('modalMarsMed.GivenQuantity')}}</small><br>
															<b>{{$t('Shared.Notdefined')}}</b>
														</div>

														<div class="col-md-3 text-muted p-item" v-if="prnadm.reasonDescription">
															<small>{{$t('modalMarsMed.NoAdministrationReason')}}</small><br>                                                   
															<b>{{ prnadm.reasonDescription }}</b>
														</div>
														<div class="col-md-3 text-muted p-item" v-else>
															<small>{{$t('modalMarsMed.NoAdministrationReason')}}</small><br>
															<b>{{$t('Shared.Notdefined')}}</b>
														</div>

														<div class="col-md-2 text-muted p-item" v-if="prnadm.reviewedByName">
															<small>{{$t('modalMarsMed.ReviewedByName')}}</small><br>                                                   
															<b>{{ prnadm.reviewedByName }}</b>
														</div>
														<div class="col-md-2 text-muted p-item" v-else>
															<small>{{$t('modalMarsMed.ReviewedByName')}}</small><br>
															<b>{{$t('Shared.Notdefined')}}</b>
														</div>

														<div class="col-md-2 text-muted p-item" v-if="prnadm.reviewedOn">
															<small>{{$t('modalMarsMed.ReviewedOn')}}</small><br>                                                   
															<b>{{ formatDate(prnadm.reviewedOn) }}</b>
														</div>
														<div class="col-md-2 text-muted p-item" v-else>
															<small>{{$t('modalMarsMed.ReviewedOn')}}</small><br>
															<b>{{$t('Shared.Notdefined')}}</b>
														</div>												
													</div>										
												</div>
											</div>
										</div>                                       
									</div>
								</div>
							</div>    
						</div>
					</div>
					
					

				</b-card-body>
				</b-collapse>
			</b-card>         
			</div>
		</div>
		</div>    

</div>
</template>

<script>
import Utils from '@/common/utils'
//import { uuid } from 'vue-uuid'; 
export default {
    props: {
	Items: Array    
   },
    data() {
      return {	
	//	unique: uuid.v1(),	
		perPage: 10,     
        totalRows: 0, 
        currentPage: 1,   
		perPageStyle: {
			width: 'auto'
		},
		options: [
			{ value: 5, text: '5' },
			{ value: 10, text: '10' },
			{ value: 15, text: '15' },
		],
		PhotoObj:{allergies:"",}
      }
    },
    
  methods:{
	formatDate(dob) {
		return Utils.formatterDateToString(dob)
	},

	formatTime(time) {
		return Utils.formatTime(time)
	},
	HaveOneGiven(){
		return true;
	},
	HaveOneNoGiven(){
		return false;
	},
	HasMoreThanOneAlert(){
		return true;
	},
	getStatus(){

	},
	GivenNeutro(){
		return false;
	},
	IsHover(){

	},
	getTitle(){

	},
	perPageChange(){

	},
	onChange(){

	}
  },
  mounted() {

  }
}

</script>


<style scoped>

.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}

.medAdminLabel{
    padding: 0 0.8em;
    display: inline-block;
    margin-top: .4em;
    border-radius: 10px;
    font-variant-caps: all-small-caps;
    vertical-align: top !important;
    font-kerning: 5em;
    font-weight: bold;
    font-size: 0.8em;
    color: #FFF;
}
.allergicToMed{
    background-color: #F00;
    color: #FF9;
    animation: blinking 1s linear infinite;
}
.overdue{
    background-color: var(--overdue);
}
.close-to-admin{
    background-color: var(--close-to-admin);
}
.prior-to-admin{
    background-color: var(--prior-to-admin);
}
.no-pending{
    background-color: var(--no-pending);
}

@keyframes blinking {
    0%, 50% {
        color: #FF9;
    }
    100% {
        color: #F00;
    }
}
@keyframes fadingNow {
    0%, 50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.withDot::after{
    content: "●";
    color: #F00;
    position: absolute;
    top: 4px;
    left: 14px;
    animation: fadingNow 1s infinite;
}
.greenBTN{
    background-color: #0C0 !important;
    border-radius: 15px 0 0 15px !important;
    color: #6F6 !important;
}
.greenBTN:hover{
    background-color: #0F0 !important;
    box-shadow: 0 0 5px #008300;
    color: #FFF !important;
    transform: scale(1.1);
}
.redBTN{
    background-color: #C00 !important;
    border-radius: 0 15px 15px 0 !important;
    color: #F66 !important;
}
.redBTN:hover{
    background-color: #F00 !important;
    box-shadow: 0 0 5px #820000;
    color: #FFF !important;
    transform: scale(1.1);
}

/* MODAL REMAKE */
.zebraAccordion{
  /*  margin: 0 1em;*/
}
.resetFontSize small{
    font-size: .95em;
}
.zebraAccordion .zebraRow .zebraItem{
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem{
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem{
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19BEE1;
    color: #FFF;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #FFF;
}
.zItemIcon{
    width: 15%;
    margin: 0 1%;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
}

.zItemText{
    width: 86%;
    display: inline-block;
    vertical-align: middle;
}
@media (max-width: 992px) {
    .zItemIcon{
        width: 10%;
    }
    .zItemText{
        width: 75%;
    }
}
.adminTime{
	background-color: #9be8f9;
	padding: 0px 10px;
	border-radius: 10px;
	color: #FFF;
}

.quickSave{
    color: #19BEE1;
    transition: all .3s ease-in-out;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.quickSave:hover{
    color: #FFF;
}
.zebraAccordion .zebraRow .zebraItem small{
    font-size: .7em;
}
.PRNlabel{
    background-color: #6F6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all .3s ease-in-out;
}
.PRNlabel:hover{
    background-color: #FF9;
}
.opAT{
    opacity: .5;
}
.accordionContent{
    border-top: 0;
    background: linear-gradient(173deg, #D9F4FB, #FFF 30% );
    padding-top: 3em;
}

.giveMeds button{
    border: 4px solid #FFFFFFEE;
    transition: all .3s ease-in-out;
    cursor: pointer;
}
.redMed{
    border-radius: 0 50px 50px 0;
    border-left: 0;
    background-color: #660000;
    background: linear-gradient(-40deg, #FF0000, #660000);
    animation: spreadShadowLast 1s ease-in-out infinite;
}
.redMed:hover{
    background-color: #FF0000;
    background: linear-gradient(-40deg, #990000, #FF0000);
}
.redMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.greenMed{
    border-radius: 50px 0 0 50px;   
    background-color: #008236;
    background: linear-gradient(-40deg, #008236, #003300);
    border-right: 0 !important;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.greenMed i::before{
    font-size: 1.1em;
}
.greenMed:hover{
    background-color: #00CC00;
    background: linear-gradient(-40deg, #006600,#01d85b);
}
.greenMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.longDivider{
	width: 100%;
	background: linear-gradient(0deg, #FFF 0%, #FFF 43%, #9be8f9 44%, #9be8f9 57%, #FFF 58%, #FFF 100%);
}
.silverTextColor{
	color: #999;
	transition: color 3s;
}
.silverTextColor:hover{
	color: #19BEE1;
	transition: color .1s;
}

.eventHintHeader{
	padding-bottom: 2px;
	border-bottom: 1px solid silver;
  }

  .eventHint{
	text-align: left;
	padding: 0 4px 4px 4px;
	color: seashell;
	vertical-align: bottom;
  }
  .eventHint svg{
	color: white;
	margin: 10px 4px 0 0;
  }  

.GivNeutral{
    opacity: 0.2;
}

.undoMedLeft{
    background-color: #666;
    background: linear-gradient(-40deg, #EEE, #CCC);
    border: 4px solid #EEE !important;
    border-right: 0 !important;
}
.undoMedLeft:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #999, #CCC);
}
.undoMedRight{
    background-color: #666;
    background: linear-gradient(-40deg, #CCC, #EEE);
    border: 4px solid #EEE !important;
    border-left: 0 !important;
}
.undoMedRight:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #CCC, #999);
}
@keyframes spreadShadow {
    0%, 100% {
        text-shadow: 0 0 1px #00000099;
    }
    50% {
        text-shadow: 0 0 20px #000000FF;
    }
}
@keyframes spreadShadowFirst {
    0%, 100% {
        text-shadow: 0 0 1px #FFFFFF;
    }
    50% {
        text-shadow: 0 0 20px #FFFFFF;
    }
}
@keyframes spreadShadowLast {
    0%, 100% {
        text-shadow: 0 0 20px #FFFFFF, 0 0 20px #FFFFFF;
    }
    25% {
        text-shadow: 0 0 1px #FFFFFF, 0 0 1px #FFFFFF;
    }
}
</style>